import React from 'react';
import { AccountStatus, getAccountStatusLabel } from '../../../../domain/models/AccountStatus';
import { getStatusVariant } from '../../../../domain/models/AccountStatusUtils';
import { StatusBadge } from '../../../../../../shared/components/ui/StatusBadge';

interface AccountStatusIconProps {
  status: AccountStatus;
}

export const AccountStatusIcon: React.FC<AccountStatusIconProps> = ({ status }) => (
  <StatusBadge label={getAccountStatusLabel(status)} status={getStatusVariant(status)} />
);
